<ul
  [id]="groupId()"
  class="m-0 min-h-[30px] list-none p-0"
  cdkDropList
  [cdkDropListData]="buckets()"
  [cdkDropListConnectedTo]="connectedListIds()"
  (cdkDropListDropped)="bucketSortUpdate($event)"
>
  @for (bucket of visibleBuckets(); track bucket.id) {
    <li
      class="category-bucket-list-item relative flex min-w-0 items-center gap-2 overflow-hidden border-t border-border-muted first:border-t-0"
      [class.pr-category-group-x]="reorder()"
      [class.border-dashed]="bucket._pendingCreate || bulkEdit.isPendingArchive(bucket.id)"
      [class.bg-surface-subtle]="bucket._pendingCreate || bulkEdit.isPendingArchive(bucket.id)"
      [id]="bucket.id"
      [class.opacity-80]="bucket.archivedMonth || bulkEdit.isPendingArchive(bucket.id)"
      [class.!opacity-100]="bulkEdit.isPendingUnarchive(bucket.id)"
      cdkDrag
      [cdkDragData]="bucket"
      [cdkDragDisabled]="
        !reorder() || bucket._pendingCreate || bulkEdit.isPendingArchive(bucket.id) || !!bucket.archivedMonth
      "
    >
      <app-category-bucket-summary
        class="min-w-0 flex-1"
        [reorder]="reorder()"
        [bucket]="bucket"
        [archiveCandidates]="archiveCandidates()"
      />
      @if (reorder() && !bucket._pendingCreate && !bulkEdit.isPendingArchive(bucket.id) && !bucket.archivedMonth) {
        <span
          cdkDragHandle
          class="bucket-drag-handle inline-flex h-10 w-10 shrink-0 items-center justify-center self-center text-border-default"
          aria-hidden="true"
        >
          <span class="inline-flex h-[1.125rem] w-[1.125rem]">
            <app-ui-icon name="drag-handle" />
          </span>
        </span>
      }
    </li>
  }
</ul>
